// src/components/calendar/ListView.js

import React from 'react';
import PropTypes from 'prop-types';
import LoadMoreButton from 'components/common/LoadMoreButton';
import styles from './ListView.module.css';
import listStyles from 'components/news/NewsList.module.css';
import CategoryListArchives from 'components/common/CategoryListArchives';
import Button from 'components/common/Button';
import { useSubSite } from 'contexts/SubSiteContext';
import { Link } from 'react-router-dom';

const ListView = ({ events, onLoadMore, hasMore, loadingMore }) => {
  const { isSubSite, subSiteSlug } = useSubSite();

  if (events.length === 0) {
    return <div>Aucun événement disponible.</div>;
  }

  return (
    <div className="global-container">
      <ul className={`list--none ${styles.listView}`}>
        {events.map((event) => (
          <li key={event.id || event.slug} className={listStyles.listItem}>
            <div className={listStyles.content}>
              <div className={listStyles.infos}>
                <h3 className={listStyles.eventTitle}>{event.title}</h3>
                <div className={listStyles.meta}>
                  <ul className={`list--none ${styles.tagList}`}>
                    {event.categories?.map((category) => (
                      <li key={category.id || category.slug}>
                        <CategoryListArchives
                          variant={category.slug}
                          name={category.name}
                        />
                      </li>
                    ))}
                  </ul>

                  <p className={listStyles.metaItem}>
                    {event.start} {event.end && ` - ${event.end}`}
                  </p>
                  {event.location && (
                    <p className={styles.eventLocation}>{event.location}</p>
                  )}
                </div>
              </div>
              <Link
                to={
                  isSubSite
                    ? `/${subSiteSlug}/evenement/${event.slug}`
                    : `/evenement/${event.slug}`
                }
              >
                <Button variant="primary" className={listStyles.cardButton}>
                  Lire la suite
                </Button>
              </Link>
            </div>
          </li>
        ))}
      </ul>

      {hasMore && (
        <LoadMoreButton onClick={onLoadMore} disabled={loadingMore} />
      )}
    </div>
  );
};

ListView.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      start: PropTypes.string.isRequired,
      end: PropTypes.string,
      location: PropTypes.string,
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
};

ListView.defaultProps = {
  onLoadMore: undefined,
  hasMore: false,
  loadingMore: false,
};

export default ListView;
